import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import SearchInput from '../SearchInput';
import SearchResults from '../SearchResults';
import SearchWrapper from '../SearchWrapper';
import Button from '../Button';
import { classNames, isDefined } from '../../utils';
import styles from './SearchBox.module.css';
import Loader from '../Loader';
import SelectAll from '../SelectAll';
class SearchBox extends React.Component {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            document.addEventListener('click', this.handleClick);
            if (typeof this.props.onChange === 'function') {
                this.setState({ useLocalState: false });
            }
        };
        this.componentWillUnmount = () => {
            document.removeEventListener('click', this.handleClick);
        };
        this.getQueryValue = () => this.state.useLocalState ? this.state.query : this.props.query;
        this.setWrapperRef = (ref) => {
            // @ts-ignore
            this.container = ref;
        };
        this.handleQueryChange = (event) => {
            const { onChange } = this.props;
            if (typeof onChange === 'function') {
                onChange(event.target.value);
                return;
            }
            this.setState({ query: event.target.value });
        };
        this.handleClear = () => {
            const { onChange } = this.props;
            if (typeof onChange === 'function') {
                onChange('');
                return;
            }
            this.setState({ query: '' });
        };
        this.handleClick = (event) => {
            if (this.props.noClickOutsideDetection) {
                return;
            }
            // @ts-ignore
            if (!this.container.current.contains(event.target)) {
                this.handleClose();
            }
        };
        this.handleOpen = () => {
            const { externalControlOpen, externalControlSetOpen } = this.props;
            if (externalControlOpen === undefined) {
                this.setState({
                    isOpen: true,
                });
            }
            else if (externalControlSetOpen !== undefined) {
                externalControlSetOpen(true);
            }
        };
        this.handleClose = () => {
            const { externalControlOpen, externalControlSetOpen } = this.props;
            if (externalControlOpen !== undefined &&
                externalControlSetOpen !== undefined) {
                if (this.state.keepOpenFirstTime) {
                    this.setState({ keepOpenFirstTime: false });
                }
                else {
                    externalControlSetOpen(false);
                }
            }
            else {
                if (this.props.close) {
                    this.props.close();
                    return;
                }
                if (this.state.keepOpenFirstTime) {
                    this.setState({ keepOpenFirstTime: false });
                }
                else {
                    this.setState({
                        isOpen: false,
                    });
                }
            }
        };
        this.state = {
            isOpen: props.startOpen || false,
            query: '',
            useLocalState: true,
            keepOpenFirstTime: true,
        };
    }
    render() {
        const query = this.getQueryValue();
        const { isOpen } = this.state;
        const { color = 'shade', width, widthActive, items = [], placeholder, withDropdown, isInDropdown = false, error, searchCloseText = '', onSelectAll, areAnySelected, selectAllText, actions, hasCloseButton, externalControlOpen, } = this.props;
        const isReallyOpen = externalControlOpen === undefined ? isOpen : externalControlOpen;
        const hasItems = items.length > 0;
        return (_jsxs(SearchWrapper, Object.assign({ wrapperRef: this.setWrapperRef, active: isReallyOpen, width: width, widthActive: widthActive, className: isInDropdown ? styles.searchWrapperInDropdown : '' }, { children: [_jsx(SearchInput, { active: isReallyOpen, color: color, value: query || '', onFocus: this.handleOpen, onChange: this.handleQueryChange, placeholder: placeholder, error: error, onClear: this.handleClear }, void 0), isReallyOpen &&
                    (onSelectAll || withDropdown || actions || hasCloseButton) && (_jsxs("div", Object.assign({ className: classNames(styles.openContainer, isInDropdown ? styles.openContainerInDropdown : '') }, { children: [onSelectAll && areAnySelected !== undefined && hasItems && (_jsx(SelectAll, { selectAllText: selectAllText, areAnySelected: areAnySelected, toggleSelectAll: onSelectAll }, void 0)), withDropdown && (_jsx(SearchResults, Object.assign({ active: isReallyOpen, color: color, className: isInDropdown ? styles.searchResultsInDropdown : '' }, { children: hasItems ? items : !query ? _jsx(Loader, {}, void 0) : null }), void 0)), (hasCloseButton || actions) && (_jsxs("div", Object.assign({ className: classNames(styles.actionsFooter, isInDropdown ? styles.actionsFooterInDropdown : '') }, { children: [hasItems && hasCloseButton && (_jsx(Button, Object.assign({ size: "small", variant: "text", onClick: () => this.handleClose() }, { children: searchCloseText || 'Cancel' }), void 0)), hasItems &&
                                    isDefined(actions) &&
                                    React.cloneElement(actions, {
                                        closeFunction: this.handleClose,
                                    })] }), void 0))] }), void 0))] }), void 0));
    }
}
export default SearchBox;
